import React from "react";
import { formatCount } from "../../../utils/numberFormat";

const DistrictPerformance = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg p-6 shadow-sm animate-pulse">
        <div className="h-6 bg-gray-300 rounded w-1/3 mb-4"></div>
        <div className="h-48 bg-gray-200 rounded"></div>
      </div>
    );
  }

  // Format count function
  const formatPercentage = (value) => {
    if (!value) return "0.00%";
    return `${parseFloat(value).toFixed(2)}%`;
  };
  const districtData = data?.districts || [];
  const villageData = data?.villages || [];
  const calculateDistrictTotals = () => {
    let totalImplementations = 0;
    let totalCompleted = 0;
    let totalInProgress = 0;
    let totalPending = 0;
    let totalCancelled = 0;

    districtData.forEach((district) => {
      totalImplementations += parseInt(district.total || 0);
      totalCompleted += parseInt(district.completed || 0);
      totalInProgress += parseInt(district.inProgress || 0);
      totalPending += parseInt(district.pending || 0);
      totalCancelled += parseInt(district.cancelled || 0);
    });

    const overallCompletionRate =
      totalImplementations > 0
        ? ((totalCompleted / totalImplementations) * 100).toFixed(2)
        : "0.00";

    return {
      totalImplementations,
      totalCompleted,
      totalInProgress,
      totalPending,
      totalCancelled,
      overallCompletionRate,
    };
  };

  const districtTotals = calculateDistrictTotals();
  const calculateVillageTotals = () => {
    let villageTotalImplementations = 0;
    let villageTotalCompleted = 0;
    let villageOverallCompletion = 0;

    villageData.forEach((village) => {
      villageTotalImplementations += parseInt(
        village.totalImplementations || 0
      );
      villageTotalCompleted += parseInt(village.completed || 0);
    });

    villageOverallCompletion =
      villageTotalImplementations > 0
        ? ((villageTotalCompleted / villageTotalImplementations) * 100).toFixed(
            2
          )
        : "0.00";

    return {
      villageTotalImplementations,
      villageTotalCompleted,
      villageOverallCompletion,
    };
  };

  const villageTotals = calculateVillageTotals();

  return (
    <div className="bg-white rounded-lg shadow-sm">
      {/* District Performance Table */}
      {/* <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 mb-8">
        <div className="lg:col-span-12">
          <h3 className="text-xl font-bold uppercase text-[#3A3A3A] mb-3 text-center text-balance">
            District Implementation Performance
          </h3>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse">
              <thead>
                <tr>
                  <th className="px-4 py-3 text-left text-white bg-[#137e81] font-medium">
                    District
                  </th>
                  <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                    Total Implementations
                  </th>
                  <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                    Completed
                  </th>
                  <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                    In Progress
                  </th>
                  <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                    Pending
                  </th>
                  <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                    Cancelled
                  </th>
                  <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                    Completion Rate
                  </th>
                </tr>
              </thead>
              <tbody>
                {districtData && districtData.length > 0 ? (
                  districtData.map((district, index) => {
                    const completionRate =
                      district.total > 0
                        ? ((district.completed / district.total) * 100).toFixed(
                            2
                          )
                        : "0.00";

                    return (
                      <tr
                        key={`district-${index}`}
                        className={`${
                          index % 2 === 0 ? "bg-[#F6F7F9]" : "bg-white"
                        } hover:bg-gray-100 transition-colors`}
                      >
                        <td className="px-4 py-3 text-gray-800 border-b font-medium">
                          {district.districtName || district.name || "N/A"}
                        </td>
                        <td className="px-4 py-3 text-center border-b font-semibold">
                          {formatCount(
                            parseInt(
                              district.total ||
                                district.totalImplementations ||
                                0
                            )
                          )}
                        </td>
                        <td className="px-4 py-3 text-center border-b font-semibold">
                          {formatCount(parseInt(district.completed || 0))}
                        </td>
                        <td className="px-4 py-3 text-center border-b font-semibold">
                          {formatCount(parseInt(district.inProgress || 0))}
                        </td>
                        <td className="px-4 py-3 text-center border-b font-semibold">
                          {formatCount(parseInt(district.pending || 0))}
                        </td>
                        <td className="px-4 py-3 text-center border-b font-semibold">
                          {formatCount(parseInt(district.cancelled || 0))}
                        </td>
                        <td className="px-4 py-3 text-center border-b font-semibold">
                          <div className="flex items-center justify-center space-x-2">
                            <span
                              className={`font-bold ${
                                parseFloat(completionRate) >= 80
                                  ? "text-gray-800"
                                  : parseFloat(completionRate) >= 50
                                  ? "text-gray-800"
                                  : "text-gray-800"
                              }`}
                            >
                              {completionRate}%
                            </span>
                            <div className="w-16 bg-gray-200 rounded-full h-2">
                              <div
                                className={`h-2 rounded-full ${
                                  parseFloat(completionRate) >= 80
                                    ? "bg-[#137E81]"
                                    : parseFloat(completionRate) >= 50
                                    ? "bg-[#137E81]"
                                    : "bg-[#137E81]"
                                }`}
                                style={{
                                  width: `${Math.min(
                                    parseFloat(completionRate),
                                    100
                                  )}%`,
                                }}
                              ></div>
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td
                      colSpan="7"
                      className="px-4 py-8 text-center text-gray-500 border-b"
                    >
                      {loading
                        ? "Loading district performance data..."
                        : "No district performance data available"}
                    </td>
                  </tr>
                )}

                {/* District Grand Totals Row */}
                {/* {districtData && districtData.length > 0 && (
                  <tr className="bg-[#137e81] text-white font-bold">
                    <td className="px-4 py-3 text-left border-b">
                      GRAND TOTAL
                    </td>
                    <td className="px-4 py-3 text-center border-b">
                      {formatCount(districtTotals.totalImplementations)}
                    </td>
                    <td className="px-4 py-3 text-center border-b">
                      {formatCount(districtTotals.totalCompleted)}
                    </td>
                    <td className="px-4 py-3 text-center border-b">
                      {formatCount(districtTotals.totalInProgress)}
                    </td>
                    <td className="px-4 py-3 text-center border-b">
                      {formatCount(districtTotals.totalPending)}
                    </td>
                    <td className="px-4 py-3 text-center border-b">
                      {formatCount(districtTotals.totalCancelled)}
                    </td>
                    <td className="px-4 py-3 text-center border-b">
                      <div className="flex items-center justify-center space-x-2">
                        <span
                          className={`font-bold ${
                            parseFloat(districtTotals.overallCompletionRate) >=
                            80
                              ? "text-white"
                              : parseFloat(
                                  districtTotals.overallCompletionRate
                                ) >= 50
                              ? "text-white"
                              : "text-white"
                          }`}
                        >
                          {districtTotals.overallCompletionRate}%
                        </span>
                        <div className="w-16 bg-gray-300 rounded-full h-2">
                          <div
                            className={`h-2 rounded-full ${
                              parseFloat(
                                districtTotals.overallCompletionRate
                              ) >= 80
                                ? "bg-white"
                                : parseFloat(
                                    districtTotals.overallCompletionRate
                                  ) >= 50
                                ? "bg-white"
                                : "bg-white"
                            }`}
                            style={{
                              width: `${Math.min(
                                parseFloat(
                                  districtTotals.overallCompletionRate
                                ),
                                100
                              )}%`,
                            }}
                          ></div>
                        </div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div> */}
      {/* </div>  */}
      {villageData.length > 0 && (
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-4">
          <div className="lg:col-span-12">
            <h3 className="text-xl font-bold uppercase text-[#3A3A3A] mb-3 text-center text-balance">
              Village-wise Implementation Performance
            </h3>
            <div className="overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr>
                    <th className="px-4 py-3 text-left text-white bg-[#137e81] font-medium">
                      Village
                    </th>
                    <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                      District
                    </th>
                    <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                      Total Implementations
                    </th>
                    <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                      Completed
                    </th>
                    <th className="px-4 py-3 text-center text-white bg-[#137e81] font-medium">
                      Completion Rate
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {villageData.map((village, index) => (
                    <tr
                      key={`village-${index}`}
                      className={`${
                        index % 2 === 0 ? "bg-[#F6F7F9]" : "bg-white"
                      } hover:bg-gray-100 transition-colors`}
                    >
                      <td className="px-4 py-3 text-gray-800 border-b font-medium">
                        {village.villageName || "N/A"}
                      </td>
                      <td className="px-4 py-3 text-center border-b font-medium">
                        {village.districtName || "N/A"}
                      </td>
                      <td className="px-4 py-3 text-center border-b font-semibold">
                        {formatCount(
                          parseInt(village.totalImplementations || 0)
                        )}
                      </td>
                      <td className="px-4 py-3 text-center border-b font-semibold">
                        {formatCount(parseInt(village.completed || 0))}
                      </td>
                      <td className="px-4 py-3 text-center border-b font-semibold">
                        <div className="flex items-center justify-center space-x-2">
                          <span
                            className={`font-bold ${
                              parseFloat(village.completionRate) >= 80
                                ? "text-gray-800"
                                : parseFloat(village.completionRate) >= 50
                                ? "text-gray-800"
                                : "text-gray-800"
                            }`}
                          >
                            {formatPercentage(village.completionRate)}
                          </span>
                          <div className="w-16 bg-gray-200 rounded-full h-2">
                            <div
                              className={`h-2 rounded-full ${
                                parseFloat(village.completionRate) >= 80
                                  ? "bg-[#137E81]"
                                  : parseFloat(village.completionRate) >= 50
                                  ? "bg-[#137E81]"
                                  : "bg-[#137E81]"
                              }`}
                              style={{
                                width: `${Math.min(
                                  parseFloat(village.completionRate || 0),
                                  100
                                )}%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {villageData.length > 0 && (
                    <tr className="bg-[#137e81] text-white font-bold">
                      <td className="px-4 py-3 text-left border-b" colSpan="2">
                        VILLAGE TOTAL
                      </td>
                      <td className="px-4 py-3 text-center border-b">
                        {formatCount(villageTotals.villageTotalImplementations)}
                      </td>
                      <td className="px-4 py-3 text-center border-b">
                        {formatCount(villageTotals.villageTotalCompleted)}
                      </td>
                      <td className="px-4 py-3 text-center border-b">
                        <div className="flex items-center justify-center space-x-2">
                          <span
                            className={`font-bold ${
                              parseFloat(
                                villageTotals.villageOverallCompletion
                              ) >= 80
                                ? "text-white"
                                : parseFloat(
                                    villageTotals.villageOverallCompletion
                                  ) >= 50
                                ? "text-white"
                                : "text-white"
                            }`}
                          >
                            {villageTotals.villageOverallCompletion}%
                          </span>
                          <div className="w-16 bg-gray-300 rounded-full h-2">
                            <div
                              className={`h-2 rounded-full ${
                                parseFloat(
                                  villageTotals.villageOverallCompletion
                                ) >= 80
                                  ? "bg-white"
                                  : parseFloat(
                                      villageTotals.villageOverallCompletion
                                    ) >= 50
                                  ? "bg-white"
                                  : "bg-white"
                              }`}
                              style={{
                                width: `${Math.min(
                                  parseFloat(
                                    villageTotals.villageOverallCompletion
                                  ),
                                  100
                                )}%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DistrictPerformance;
